import { render, staticRenderFns } from "./tags-edit-modal.vue?vue&type=template&id=5d8c322c&scoped=true"
import script from "./tags-edit-modal.vue?vue&type=script&lang=ts"
export * from "./tags-edit-modal.vue?vue&type=script&lang=ts"
import style0 from "./tags-edit-modal.vue?vue&type=style&index=0&id=5d8c322c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c322c",
  null
  
)

export default component.exports